__turbopack_context__.v({
  "actions": "studio-module__wtQASG__actions",
  "badges": "studio-module__wtQASG__badges",
  "before": "studio-module__wtQASG__before",
  "controls": "studio-module__wtQASG__controls",
  "current": "studio-module__wtQASG__current",
  "error": "studio-module__wtQASG__error",
  "eyebrow": "studio-module__wtQASG__eyebrow",
  "file": "studio-module__wtQASG__file",
  "filters": "studio-module__wtQASG__filters",
  "hairEntry": "studio-module__wtQASG__hairEntry",
  "hairShades": "studio-module__wtQASG__hairShades",
  "intro": "studio-module__wtQASG__intro",
  "loading": "studio-module__wtQASG__loading",
  "mirror": "studio-module__wtQASG__mirror",
  "next": "studio-module__wtQASG__next",
  "note": "studio-module__wtQASG__note",
  "presetGrid": "studio-module__wtQASG__presetGrid",
  "presets": "studio-module__wtQASG__presets",
  "primary": "studio-module__wtQASG__primary",
  "privacy": "studio-module__wtQASG__privacy",
  "range": "studio-module__wtQASG__range",
  "saved": "studio-module__wtQASG__saved",
  "search": "studio-module__wtQASG__search",
  "sectionTitle": "studio-module__wtQASG__sectionTitle",
  "status": "studio-module__wtQASG__status",
  "studio": "studio-module__wtQASG__studio",
  "subtle": "studio-module__wtQASG__subtle",
  "swatches": "studio-module__wtQASG__swatches",
  "tabs": "studio-module__wtQASG__tabs",
  "turn": "studio-module__wtQASG__turn",
  "uploadRow": "studio-module__wtQASG__uploadRow",
  "visual": "studio-module__wtQASG__visual",
  "workspace": "studio-module__wtQASG__workspace",
});
